import Http from '../util/Http';

class SlotApi {

    static getSelectParams(page, count, search = '', groupId = '', slotType) {
        const params = {
            page,
            count,
            search,
            isTotalCnt : !page && !count,
            slotType
        };
        if (groupId) {
            params.groupId = groupId;
        }
        return new URLSearchParams(params).toString();
    }

    static async getSlot(slotId, isSelfLoading = false) {
        const res = await Http.get(`/slot/${slotId}?isSelfLoading=${isSelfLoading}`);
        return res || {};
    }

    static async getSlots(page = 1, count = 10, search, groupId, slotType) {
        const queryString = this.getSelectParams(page, count, search, groupId, slotType);
        const res = await Http.get(`/slot?${queryString}`);
        return res || [];
    }

    static async getSlotTotalCnt(search, groupId, slotType) {
        const queryString = this.getSelectParams(0, 0, search, groupId, slotType);
        const res = await Http.get(`/slot?${queryString}`);
        return res || [];
    }

    // Create a new slot
    static async createSlot(slotData) {
        const res = await Http.post('/slot', slotData);
        return res || null;
    }

    // Update multiple slots
    static async updateSlots(slots) {
        const res = await Http.put('/slot', { slots });
        return res || null;
    }

    // Update multiple slots
    static async updateSlotsGroup(slotIds, groupId) {
        const res = await Http.put('/slot/group', { slotIds, groupId });
        return res || null;
    }

    // Delete multiple slots by their IDs
    static async deleteSlots(slotIds) {
        const res = await Http.post('/slot/delete', { slotIds });
        return res || null;
    }

    static async reduceSlotCount(count) {
        const res = await Http.post('/slot/reduce', { count });
        return res || null;
    }

    static async updateSlotMemo(slotId, slotMemo) {
        const res = await Http.post('/slot/memo', { slotId, slotMemo });
        return res || null;
    }

    static async xlsDownload(slotIds) {
        const res = await Http.download('/slot/xlsDownload?slotIds=' + slotIds.join(','))
        return res || null;
    }

    static async reIndexSlot(slots) {
        const res = await Http.post('/slot/reIndex', { slots });
        return res || null;
    }

    static async getPopularKeyword() {
        const res = await Http.get('/slot/popularKeyword');
        return res || null;
    }

}

export default SlotApi;
